import type { StampCardDiscount } from "~/api/products/types";
import { roundAwayFromZero } from "~/utils/round-away-from-zero";

type ResolveStampCardBaseDiscountArgs = {
  /** Per-unit incl-VAT base price, already weight-adjusted for weighted products. */
  baseUnitPriceInclVat: number;
  discountType: StampCardDiscount["discountType"];
  discount: StampCardDiscount["discount"];
};

export function resolveStampCardBaseDiscount({
  baseUnitPriceInclVat,
  discountType,
  discount
}: ResolveStampCardBaseDiscountArgs): number {
  const base = roundAwayFromZero(baseUnitPriceInclVat);

  const amount =
    discountType === "percentage" ? base * (discount / 100) : discount;

  // Never exceed the base price nor go negative — the reward can't eat into the
  // options, and a currency reward larger than the product is capped.
  return Math.min(Math.max(amount, 0), base);
}

/** The price shown for a stamp card product, in whole minor units like the reward it subtracts. */
export function resolveStampCardDiscountedPrice(
  args: ResolveStampCardBaseDiscountArgs
): number {
  return (
    roundAwayFromZero(args.baseUnitPriceInclVat) -
    resolveStampCardBaseDiscount(args)
  );
}
